import React from 'react';

export function DevelopmentBanner() {
  return (
    <div className="fixed bottom-4 right-4 z-[100] flex items-center gap-3 bg-black/80 backdrop-blur-sm px-4 py-3 rounded-lg border border-blue-600/30 shadow-lg overflow-hidden group">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-purple-600/10 animate-pulse" />
      
      <img 
        src="https://i.imgur.com/oA3QPXW.png" 
        alt="LynxPulse Logo" 
        className="w-8 h-8 object-contain"
      />
      
      <div className="flex flex-col">
        <span className="text-blue-400 font-bold text-xs tracking-wider">
          BY LYNXPULSE
        </span>
        <span className="text-white font-bold text-sm">
          UNDER DEVELOPMENT
        </span>
      </div>
      
      <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-blue-500/20 to-transparent animate-[pulse_2s_ease-in-out_infinite]" />
    </div>
  );
}